module.exports = __webpack_public_path__ + "img/1587880682.f9cb4eb0.jpg";